import { render, staticRenderFns } from "./NotRatedOptionReasonSelect.vue?vue&type=template&id=a227db04"
import script from "./NotRatedOptionReasonSelect.vue?vue&type=script&lang=ts"
export * from "./NotRatedOptionReasonSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports